<template>
  <div class="site">
    <!-- 地址列表 -->
    <van-address-list v-model="chosenAddressId" :list="list" @select="select" @add="onAdd" @edit="onEdit" />
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [],
        chosenAddressId: 1, //默认选择地址
      }
    },
    created() {
      //获取地址信息
      let messages = {};
      this.$axios.post(baseUrl + '/mobile/User/userAddress', {
        token: localStorage.getItem('Authorization')
      }).then((res) => {
        if (res.data.code == 2) {
          for (var i = 0; i < res.data.data.length; i++) {
            messages.id = res.data.data[i].id;
            messages.name = res.data.data[i].real_name;
            messages.tel = res.data.data[i].phone;
            messages.isDefault = res.data.data[i].state;
            messages.areaCode = res.data.data[i].areaCode;
            messages.address = res.data.data[i].province + res.data.data[i].city + res.data.data[i].area + res.data.data[i].address;
            this.list.push(messages);
            messages = {};
            if (res.data.data[i].state == 1) {
              this.chosenAddressId = res.data.data[i].id
            }
          }
        } else {
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    methods: {
      //地址操作
      onAdd() {
        this.$axios.post(baseUrl + '/mobile/User/addressCount', {
          token: localStorage.getItem('Authorization')
        }).then((res) => {
          if (res.data.code == 1101) {
            this.$router.push({
              path: '/address'
            })
          } else {
            this.$toast(res.data.msg)
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      //编辑地址
      onEdit(item, index) {
        this.$router.push({
          path: '/address',
          query: {
            id: item.id
          }
        })
      },
      select(item, index) {
        this.$axios.post(baseUrl + '/mobile/User/updateAddressStatus', {
          id: item.id,
          state: 1,
          token: localStorage.getItem('Authorization')
        }).then((res) => {
          if (res.data.code == 7) {
            this.back();
          } else {
            this.$toast(res.data.msg)
          }
        })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/location.vue